<template>
    <div class="identity-item-super-bg">
      <div class="identity-item-top-line"
           v-bind:style="{background:this.getCurTopLineColor(identityItemInfo.type)}"></div>
      <div class="identity-item-bg">
        <p class="identity-item-title">{{this.getCurTitle(identityItemInfo.type)}}</p>
        <div class="identity-item-sub-select-div">
          <button v-for="(item,index) in identityItemInfo.list"
                  v-bind:style="index === 0 ? {} : {'margin-top': '10px'}"
                  :class="item.select ? 'identity-item-sub-select-btn-selected' : 'identity-item-sub-select-btn'"
                  @click="itemBtnClickFun(item)">{{item.name}}</button>
        </div>
      </div>
      <button class="identity-item-enter-btn" @click='enterBtnClick'>{{this.getCurBtnTitle(identityItemInfo.type)}}</button>
    </div>
</template>

<script>
  export default {
    name: 'IdentityItem',
    props: {
      identityItemInfo: {
        required: false
      }
    },
    data () {
      return {

      }
    },
    methods: {
      itemBtnClickFun (item ,event) {
        this.clearAllSelect()
        item.select = true
      },
      enterBtnClick () {
        let item = this.getSelectItem()
        this.$emit('enterBtnClick', item, this.identityItemInfo.type)
      },
      getSelectItem () {
        for (let i = 0; i < this.identityItemInfo.list.length; i++) {
          let item = this.identityItemInfo.list[i]
          if (item.select) {
            return item
          }
        }
      },
      clearAllSelect () {
        for (let i = 0; i < this.identityItemInfo.list.length; i++) {
          let item = this.identityItemInfo.list[i]
          item.select = false
        }
      },
      getCurTopLineColor (type) {
        if (type === 'group') {
          return '#D0021B'
        } else if (type === 'assistant') {
          return '#417505'
        } else if (type === 'teacher') {
          return '#4A90E2'
        } else if (type === 'student') {
          return '#F5A623'
        }
      },
      getCurBtnTitle (type) {
        if (type === 'group') {
          return '机构认证'
        } else if (type === 'assistant') {
          return '进入课表'
        } else if (type === 'teacher') {
          return '进入课表'
        } else if (type === 'student') {
          return '开始学习'
        }
      },
      getCurTitle (type) {
        if (type === 'group') {
          return '我是机构'
        } else if (type === 'assistant') {
          return '我是助教'
        } else if (type === 'teacher') {
          return '我是老师'
        } else if (type === 'student') {
          return '我是学生'
        }
      }
    }
  }
</script>

<style scoped>
  .identity-item-super-bg{
    text-align: center;
  }
  .identity-item-top-line{
    width: 76.83%;
    height: 7px;
    margin: 0 auto;
    z-index: 100;
  }
  .identity-item-bg{
    width: 100%;
    height: 228px;
    border-radius:8px;
    border:1px solid rgba(93,192,186,1);
    background: #FFFFFF;
  }
  .identity-item-title{
    margin: 0 auto;
    margin-top: 30px;
    width:112px;
    height:40px;
    font-size:28px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color: #4A4A4A;
    line-height:40px;
  }
  .identity-item-enter-btn{
    width:154px;
    height:40px;
    margin-top: 23px;
    color: #FFFFFF;
    font-size:18px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    background:rgba(93,192,186,1);
    border-radius:35px;
    cursor: pointer;
  }
  .identity-item-sub-select-div{
    width: 197px;
    height: 106px;
    margin: 0 auto;
    margin-top: 32px;
    overflow:scroll;
  }
  .identity-item-sub-select-btn{
    width:197px;
    height:48px;
    background:rgba(255,255,255,0.92);
    border-radius:5px;
    border:1px solid rgba(93,192,186,1);
    font-size:20px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(93,192,186,1);
    line-height:28px;
    cursor: pointer;
  }
  .identity-item-sub-select-btn-selected{
    width:197px;
    height:48px;
    background:rgba(93,192,186,1);
    border-radius:5px;
    font-size:20px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:28px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/IdentityItem.vue